import { createFileRoute, redirect } from '@tanstack/react-router';

type SsoErrorSearch = {
  error?: string;
};

export const Route = createFileRoute('/_auth/sso/error')({
  staticData: {
    pageName: 'SSO Error',
  },
  validateSearch: (search: Record<string, unknown>): SsoErrorSearch => ({
    error: (search.error as string) ?? undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/sso',
      search: { error: search.error },
    });
  },
});
